/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Notifications/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Notifications({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/Appointment/Content/Content/Notifications",
  onClickNextMonth
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appointmentWidgetRequestScheduleSlotsValueData = fromData.useDataFormat({ viewPath,
context: 'appointment_widget_request_schedule_slots',
format: fromHelpers.isNotEmptyObject,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(appointmentWidgetRequestScheduleSlotsValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 onClick={onClickNextMonth}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}